import React from 'react';
import Skeleton from 'react-loading-skeleton';

const UserSkeleton = () => {
  const styles = {
    top: {
      marginTop: 30,
    },
  };
  return (
    <Skeleton count={1} width={350} height={600} borderRadius={15} style={styles.top} />
  );
};

export default UserSkeleton;
